import { SettingDetailFormValues, SettingEditFormValues, } from "./types";

/*-------------------------------------------------------------------------------------------
  SETTING DETAILS
---------------------------------------------------------------------------------------------*/
export const initialSettingDetailForm: SettingDetailFormValues = {
  rtvFee: null,
  fireExtinguisher: null,
  mandatoryEquipment: null,
  offerSaleFormatNumber: null,
  offerSaleDurationDays: null,
  offerSaleNoteDefault: null,
  contractSaleFormatNumber: null,
  contractSaleDeliveryTime: null,
  contractSalePlaceOfVehicleDelivery: null,
  invoiceFormatNumber: null,
  invoicePaymentIBAN: null,
  tenantOib: null,
  inVatSystem: true,
  businessUnitMark: null,
  cashRegisterMark: null,
  operaterOib: null,
  fiscalizationDemoMode: true,
};

/*-------------------------------------------------------------------------------------------
  SETTING EDIT
---------------------------------------------------------------------------------------------*/

export const initialSettingEditForm: SettingEditFormValues = {
  id: null,
  rtvFee: null,
  fireExtinguisher: null,
  mandatoryEquipment: null,
  offerSaleFormatNumber: null,
  offerSaleDurationDays: null,
  offerSaleNoteDefault: null,
  contractSaleFormatNumber: null,
  contractSaleDeliveryTime: null,
  contractSalePlaceOfVehicleDelivery: null,
  invoiceFormatNumber: null,
  invoicePaymentIBAN: null,
  tenantOib: null,
  inVatSystem: true,
  businessUnitMark: null,
  cashRegisterMark: null,
  operaterOib: null,
  fiscalizationDemoMode: true,
};


/*-------------------------------------------------------------------------------------------
TAX RATES
---------------------------------------------------------------------------------------------*/

export const TAX_RATE_OPTIONS = [
  { label: "5 %", value: 5 },
  { label: "13 %", value: 13 },
  { label: "25 %", value: 25 },
];

/*---------------------------------------------------------------
  SETTING - OFFER - DISCOUNT TYPE
---------------------------------------------------------------*/

export const DiscountType = {
  AMOUNT: {
    key: "AMOUNT",
    label: "Popust (€)",
  },
  PERCENTAGE: {
    key: "PERCENTAGE",
    label: "Popust (%)",
  },
} as const;




export const EUROPEAN_COUNTRIES = [
  { value: "Albania", text: "Albania" },
  { value: "Andorra", text: "Andorra" },
  { value: "Austria", text: "Austria" },
  { value: "Belarus", text: "Belarus" },
  { value: "Belgium", text: "Belgium" },
  { value: "Bosnia and Herzegovina", text: "Bosnia and Herzegovina" },
  { value: "Bulgaria", text: "Bulgaria" },
  { value: "Croatia", text: "Croatia" },
  { value: "Cyprus", text: "Cyprus" },
  { value: "Czech Republic", text: "Czech Republic" },
  { value: "Denmark", text: "Denmark" },
  { value: "Estonia", text: "Estonia" },
  { value: "Finland", text: "Finland" },
  { value: "France", text: "France" },
  { value: "Germany", text: "Germany" },
  { value: "Greece", text: "Greece" },
  { value: "Hungary", text: "Hungary" },
  { value: "Iceland", text: "Iceland" },
  { value: "Ireland", text: "Ireland" },
  { value: "Italy", text: "Italy" },
  { value: "Kosovo", text: "Kosovo" },
  { value: "Latvia", text: "Latvia" },
  { value: "Liechtenstein", text: "Liechtenstein" },
  { value: "Lithuania", text: "Lithuania" },
  { value: "Luxembourg", text: "Luxembourg" },
  { value: "Malta", text: "Malta" },
  { value: "Moldova", text: "Moldova" },
  { value: "Monaco", text: "Monaco" },
  { value: "Montenegro", text: "Montenegro" },
  { value: "Netherlands", text: "Netherlands" },
  { value: "North Macedonia", text: "North Macedonia" },
  { value: "Norway", text: "Norway" },
  { value: "Poland", text: "Poland" },
  { value: "Portugal", text: "Portugal" },
  { value: "Romania", text: "Romania" },
  { value: "Russia", text: "Russia" },
  { value: "San Marino", text: "San Marino" },
  { value: "Serbia", text: "Serbia" },
  { value: "Slovakia", text: "Slovakia" },
  { value: "Slovenia", text: "Slovenia" },
  { value: "Spain", text: "Spain" },
  { value: "Sweden", text: "Sweden" },
  { value: "Switzerland", text: "Switzerland" },
  { value: "Turkey", text: "Turkey" },
  { value: "Ukraine", text: "Ukraine" },
  { value: "United Kingdom", text: "United Kingdom" },
  { value: "Vatican City", text: "Vatican City" },
];